<template>
	<UForm
		ref="form"
		class="flex max-w-md flex-col gap-4"
		:state="state"
		:schema="schema"
		submit.prevent
	>
		<UFormField name="username" label="Benutzername">
			<UInput
				v-model="state.username"
				label="Benutzername"
				placeholder="Benutzername"
				icon="i-heroicons-user"
			/>
		</UFormField>
		<UFormField name="password" label="Passwort">
			<template #help>
				<NuxtLink to="/forgotpassword" class="text-sm">
					Passwort vergessen?
				</NuxtLink>
			</template>
			<template #default>
				<UInput
					v-model="state.password"
					label="Passwort"
					placeholder="Passwort"
					:type="passwordVisible ? 'text' : 'password'"
					icon="i-heroicons-lock-closed"
				>
					<template #trailing>
						<UIcon
							:name="
								passwordVisible ? 'i-heroicons-eye-slash' : 'i-heroicons-eye'
							"
							class="cursor-pointer text-neutral-600"
							@click.stop="togglePasswordVisibility"
						/>
					</template>
				</UInput>
			</template>
		</UFormField>
		<UAlert
			v-if="hasError"
			type="error"
			title="Das hat nicht geklappt!"
			icon="i-heroicons-exclamation-circle"
			description="Benutzername oder Passwort falsch."
			color="error"
			variant="soft"
		/>
		<UButton
			block
			icon="i-heroicons-chevron-right"
			trailing
			class="mt-6"
			:loading="loading"
			@click="submitLogin"
		>
			Login
		</UButton>
	</UForm>
</template>

<script setup lang="ts">
import * as Yup from 'yup'

const userStore = useUserStore()
const loading = ref(false)
const hasError = ref(false)

const form = ref()
const state = ref({
	username: '',
	password: '',
})

const schema = Yup.object({
	username: Yup.string().required('Bitte Benutzernamen eingeben.'),
	password: Yup.string().required('Bitte Passwort eingeben.'),
})

const passwordVisible = ref(false)

async function submitLogin() {
	loading.value = true
	// Check validity of the form
	try {
		await form.value.validate()
	} catch (error) {
		console.log('validation error', error)
		loading.value = false
		return
	}

	try {
		// Call to login the user
		await userStore.loginUser(state.value.username, state.value.password)

		umTrackEvent('login', {
			category: 'user',
			action: 'login',
			label: 'login',
		})

		// Navigate
		if (userStore.user && userStore.user.role.name == 'admin') {
			await navigateTo('/admin')
		} else {
			await navigateTo('/benutzer')
		}
	} catch (error) {
		console.log('error', error)
		hasError.value = true
	} finally {
		loading.value = false
	}
}

function togglePasswordVisibility() {
	passwordVisible.value = !passwordVisible.value
}

onUnmounted(() => {
	loading.value = false
	hasError.value = false
})
</script>

<style scoped></style>
